import { ActionType } from "../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { AccountRole } from "../../../Wrap/Models/Domains/Account/AccountRole";
import { AccountRoleDispatcher, FluxResponse } from "./Variable";
export interface AccountRoleStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    accountRoles?: AccountRole[];
}
export class AccountRoleStoreStaic extends BaseStore<AccountRoleStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AccountRoleDispatcher, (actionData) => this.onAccountRoleStoreResponse(actionData));
    }
    onAccountRoleStoreResponse(actionData: FluxResponse): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ accountRoles: actionData.payload, actionType: ActionType.Success, isLoading: false });
                break;
            case ActionType.Error:
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getAccountRoles() {
        return this.getState().accountRoles;
    }
    protected getDefaultState(): AccountRoleStoreStaticState {
        return { actionType: ActionType.Loading };
    }
}
